import React, { Component } from "react";
import Page from "Pages/_Layouts/DefaultInternal";
import useCompleoReactHookForm from "customHooks/useCompleoReactHookForm";
import useGetMetadata from "customHooks/useGetMetadata";
import { useTranslation } from "react-i18next";
import Loading from "customHooks/useCompleoReactHookForm/helpers/Loading";
import FormClassic from "customHooks/useCompleoReactHookForm/components/FormClassic";
import useFormStyles from "customHooks/useCompleoReactHookForm/components/useFormStyles";
import CustomComponents from "./components/ScorecardCustomComponents";
import { AuthProvider, useAuthState } from "_ReactContext/AuthContext";
import { useApi, useApiCache } from "customHooks/useApi";
import { navigate } from "@gatsbyjs/reach-router";
import { useCancelButtonForm } from "customHooks/useCancelButtonForm";
import useValuesFromSource from "customHooks/useValuesFromSource";
import _ from "lodash";

const ScorecardNew = (props: any) => {
    const cancelFunction = useCancelButtonForm("/scorecard/list");
    const classes = useFormStyles();
    const { company } = useAuthState();
    const moduleName = "SCORECARDEDIT";
    const [t, i18n, readyTranslation] = useTranslation(moduleName, {
        useSuspense: false
    });
    const postAddress = `/scorecard/edit`;
    const [editScorecardReturn, editScorecard] = useApi(postAddress, "post");
    const [metadata] = useGetMetadata(moduleName);

    const postAddressSearch = `/scorecard/search`;
    const [getScorecardSearchResult] = useApiCache(
        postAddressSearch,
        "post",
        { uuid: props.uuid, companyId: company.companyId },
        false
    );

    const [valuesFromSource] = useValuesFromSource(
        metadata,
        true,
        {},
        getScorecardSearchResult,
        ["data", "data", "Items"]
    );
    valuesFromSource.uuid = props.uuid;
    valuesFromSource.deleted = false;
    const ready =
        readyTranslation && getScorecardSearchResult.status === "success";

    const [formCompleo, finished] = useCompleoReactHookForm({
        t: t,
        ready: ready,
        i18nV: i18n,
        postMethod: editScorecard,
        postReturn: editScorecardReturn,
        redirectAddress: "/scorecard/list",
        FormType: FormClassic,
        metadadosRetorno: metadata,
        valuesFromSource: valuesFromSource,
        CustomComponents: CustomComponents,
        secondaryButtonFunction: cancelFunction
    });

    let compRetorno: boolean | JSX.Element;
    compRetorno = <Loading />;

    if (finished && readyTranslation) {
        compRetorno = formCompleo;
        return (
            <Page
                featureName={t("a_FeatureName")}
                featureMainDescription={t("a_FeatureMainDescription")}
                maxWidth="md"
            >
                {compRetorno}
            </Page>
        );
    } else {
        return <Page>{compRetorno}</Page>;
    }
};

// UserNew.whyDidYouRender = true;
export default ScorecardNew;
